import { alpha } from '@mui/system';
export var AutocompleteTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                '.MuiInputBase-root': {
                    gap: theme.spacing(0.5),
                    padding: theme.spacing(1),
                    minHeight: 40,
                    '.MuiAutocomplete-input': {
                        // padding: `0.95px 4px 0.95px 5px`,
                        padding: theme.spacing(0.11875, 0.5, 0.11875, 0.625),
                    },
                },
            });
        },
        endAdornment: {
        // top: `calc(50% - 16px)`,
        },
        tag: function (_a) {
            var theme = _a.theme;
            return ({
                margin: 0,
                '&:not(div)': {
                    color: theme.palette.primary.contrastText,
                    backgroundColor: theme.palette.primary.main,
                    paddingLeft: theme.spacing(1),
                    paddingRight: theme.spacing(1),
                    borderRadius: 16,
                },
            });
        },
        popper: {
            '.MuiAutocomplete-listbox': {
                '.MuiAutocomplete-option': {
                    minHeight: "40px",
                    '&:hover, &.Mui-focused': {
                        backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
                    },
                    '&.Mui-selected': {
                        backgroundColor: alpha(theme.palette.greySecondary.A100, 0.5),
                    },
                },
            },
        },
        // popupIndicator: {
        //   path: {
        //     d: `path("m1844 760 4-8h-8l4 8")`,
        //     transform: `translate(-1832.001px, -744px)`,
        //   },
        // },
    },
    variants: [
        {
            props: {
                size: 'small',
            },
            style: function (_a) {
                var theme = _a.theme;
                return ({
                    '.MuiInputBase-root': {
                        minHeight: 32,
                        '&.MuiInputBase-sizeSmall': {
                            paddingTop: theme.spacing(0.375),
                            paddingBottom: theme.spacing(0.375), // 3,
                        },
                    },
                });
            },
        },
    ],
}); };
export default AutocompleteTheme;
//# sourceMappingURL=theme.js.map